import { initElementorFeedWidget } from '@sb-blocks/feed-blocks/elementor';
import '@sb-blocks/styles.css';

const configs = window.sbElementorRegistry || [];
configs.forEach(({ blockId, widgetName, globalVar, feedInitFn }) => {
	initElementorFeedWidget({
		blockId,
		widgetName,
		globalVar,
		feedInitFn: () => window[feedInitFn]?.(),
	});
});
